import React from 'react';
import styled from 'styled-components';

import { Icon } from 'semantic-ui-react'
import Auth from '../auth/'


export const Menubarunit = styled.div `
  width:100%;
  display:flex;
  justify-content:flex-start;
  nim-height:20px;
  border-top: 2px solid   #cbd9e6;
  background:white;
  
`

export const Menubartext = styled.div`
    // padding-top:8px;

        padding-top:${props=>props.drawparam.winwidth/190}px;
    font-weight:bold;
    font-size: ${props=>(props.drawparam.extrasmall ? props.drawparam.winwidth/20 : props.drawparam.winwidth/60)}px;
    color: #0a123c;
    text-align:right;
    padding-right:20px;
     /* background: #cbd9e6; */
    width:100%;
`;

const Iconbar = styled.div `
  position:relative;
  font-size: ${props=>(props.drawparam.extrasmall ? props.drawparam.winwidth/20 : props.drawparam.winwidth/60)}px;
  top:${props=>props.drawparam.winheight/180}px;
  background:white;

  padding-left:${props=>props.drawparam.winwidth/62}px;
  padding-bottom:5px;
  padding-right:${props=>(props.normalstyle? props.drawparam.winwidth/90 : props.drawparam.winwidth/62)}px;
  ${props=>(props.normalstyle ? 'padding-top:5px;': null)}
`

const Menubar = props => {

  const { drawparam } = props

    return (

          <Menubarunit drawparam={drawparam} normalstyle={drawparam.normalstyle}>
                <Iconbar drawparam={drawparam} normalstyle={drawparam.normalstyle}>
                          <Icon  style={{'color':'#092e4f', 'cursor':'pointer'}} name='bars' onClick={props.callback}/>
                </Iconbar>

                      <Menubartext drawparam={props.drawparam}>
                        {/*
<FormEnter loginFormDraw={props.loginFormDraw} />
                          */}
                          <Auth loginFormDraw={props.loginFormDraw} />
                      </Menubartext>
          </Menubarunit>


)
}
export default Menubar;
